module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Submission")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n      All submissions must be made electronically through the online submission system ("), _c('a', {
    attrs: {
      "href": ("http://" + _vm.site + ".msubmit.net/cgi-bin/main.plex"),
      "target": "_blank"
    }
  }, [_vm._v("http://" + _vm._s(_vm.site) + ".msubmit.net/cgi-bin/main.plex")]), _vm._v(").\n      Before you submit a manuscript, be sure to read all the " + _vm._s(_vm.siteName) + " Instructions for Authors/Editorial and Publishing Policies.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      You will find complete details on how to submit a manuscript when you log on to online submission system to create an author account.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b4e27ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/for-authors-submission/ForAuthorsSubmissionContent.vue
// module id = 1396
// module chunks = 1